<template>
  <div style="height: inherit">
    <!-- <div
      class="body-content-overlay"
      :class="{ show: isShowLeftSlidebar || mqShallShowLeftSidebar }"
      @click="mqShallShowLeftSidebar = isShowLeftSlidebar = false"
    /> -->
    <b-row>
      <portal to="content-renderer-sidebar-left">
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="chat-user-list-wrapper list-group scroll-area"
        >
          <b-card style="min-width: 30%">
            <b-card-body class="m-0, p-0">
              <div class="sidebar-left">
                <div class="sidebar p-2">
                  <v-jstree :data="listData" @item-click="itemClick">
                    <template slot-scope="_">
                      <div style="display: inherit">
                        <feather-icon
                          v-if="_.model.icon"
                          :icon="_.model.icon"
                        />
                        <feather-icon v-else icon="CircleIcon" />
                        {{ _.model.text }}
                      </div>
                    </template>
                  </v-jstree>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </vue-perfect-scrollbar>
      </portal>

      <section class="chat-app-window p-2">
        <content-view
          :data-menu="data"
          :tree-menu="listData"
          @reload="getListData"
        />
      </section>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import store from "@/store";
import { ref } from "@vue/composition-api";
import VJstree from "vue-jstree";
import {
  BRow,
  BCol,
  BAvatar,
  BDropdown,
  BDropdownItem,
  BForm,
  BInputGroup,
  BFormInput,
  BButton,
  BInputGroupPrepend,
  BFormCheckbox,
  BBadge,
  BButtonGroup,
  BCard,
  BCardBody,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
import { useResponsiveAppLeftSidebarVisibility } from "@core/comp-functions/ui/app";

import LayoutData from "@/layouts/LayoutData";

import {
  GetAll,
  GetTree,
  GetById,
} from "@/services/api/DefaultTemplate/MenuService";

import ContentView from "./components/ContentView.vue";

export default {
  components: {
    VJstree,
    BRow,
    BCol,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,
    draggable,
    BFormCheckbox,
    BBadge,
    BInputGroupPrepend,
    BButtonGroup,
    BCard,
    BCardBody,
    VuePerfectScrollbar,

    ContentView,
  },
  data() {
    return {
      isWait: false,
      data: {},
    };
  },
  methods: {
    itemClick(node) {
      //   console.log(node.model + " clicked !");
      GetById(node.model.id).then((response) => {
        this.data = response.data;
      });
    },
    getListData() {
      GetTree().then((res) => {
        // console.log("res", res);
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          this.listData = res.data;
        }
      });
    },
  },
  created() {
    this.getListData();
  },
  setup(props, { emit }) {
    const headerData = ref(LayoutData.header.data);
    headerData.value.title = "Menu";
    document.title = headerData.value.title;

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };

    const listData = ref([]);

    return {
      listData,
      perfectScrollbarSettings,
    };
  },
};
</script>

<style lang="scss" scoped>
.draggable-task-handle {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden;
  cursor: move;

  .todo-task-list .todo-item:hover & {
    visibility: visible;
  }
}
</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-todo.scss";
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
